import { api } from '@api'
import { Depot, DepotPostPayload } from '@types'

interface CreateDepotResponse {
  result: Depot
}

const createDepot = async (payload: DepotPostPayload) => {
  const response = await api.post<CreateDepotResponse>('/depots', { depot: payload })

  return response.data.result
}

export const DepotsApi = { createDepot }
